import { useState, useEffect } from "react";
import { TextField, Button, Box } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useUpdateGroupNameMutation } from "../../../api/managementApi";
import { useToast } from "../../../components/ui/Toast";

export default function InlineGroupNameEdit({ groupId, currentName, onDone }) {
  const { t } = useScriptMode();
  const toast = useToast();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(currentName || "");
  const [updateName, { isLoading }] = useUpdateGroupNameMutation();

  useEffect(() => {
    setDraft(currentName || "");
  }, [currentName]);

  const trimmed = draft.trim();
  const canSave =
    !!trimmed && trimmed.length >= 2 && trimmed.length <= 25 && trimmed !== currentName && !isLoading;

  const handleSave = async () => {
    if (!canSave) return;
    try {
      await updateName({ groupId, groupName: trimmed }).unwrap();
      toast.success(t("manage_rename_success"));
      setEditing(false);
      onDone && onDone();
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("manage_rename_error");
      toast.error(msg);
    }
  };

  if (!editing) {
    return (
      <Button size="small" onClick={() => setEditing(true)}>
        {t("manage_detail_rename")}
      </Button>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <TextField
        size="small"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        inputProps={{ maxLength: 25 }}
        autoFocus
      />
      <Button size="small" variant="contained" onClick={handleSave} disabled={!canSave}>
        {t("manage_detail_save")}
      </Button>
      <Button
        size="small"
        onClick={() => {
          setDraft(currentName || "");
          setEditing(false);
        }}
        disabled={isLoading}
      >
        {t("manage_detail_cancel")}
      </Button>
    </Box>
  );
}
